import VerticalFrame from './VerticalFrame/V1';
import FeaturedInstitutes from './FeaturedInstitutes/V1';
import LearnGrow from './LearnGrow/V1';
import GoldPartners from './GoldPartners/V2';
import PlatinumPartners from './PlatinumPartners/V1';

export {
  VerticalFrame,
  FeaturedInstitutes,
  LearnGrow,
  GoldPartners,
  PlatinumPartners,
};
